'use client';
import { Cbutton } from '@/components/ui/Cbutton';
import { ButtonPreset, ContainerPreset } from '@/constants/componentPresets';
import { getWitnessCardRootStyle, getWitnessCardSurfaceStyle, WITNESS_CARD_MOTION_WRAPPER_STYLE, } from './cwitnesscardStyles';
import { CwitnesscardContent, CwitnesscardGradientOverlay, } from './CwitnesscardContent';
import { StaticWitnessCardImage } from './CwitnesscardImage';
import type { CwitnesscardProps } from './Cwitnesscard.types';
export function CwitnesscardStatic({ data, isSticky, onClick, className, style, }: CwitnesscardProps) {
    return <div data-el="Cwitnesscard/Root" className={className} style={getWitnessCardRootStyle({ isSticky, style })}>
            <div style={WITNESS_CARD_MOTION_WRAPPER_STYLE}>
                <Cbutton preset={ButtonPreset.Ghost} containerPreset={ContainerPreset.WitnessCard} ariaLabel={onClick ? `Open ${data.title}` : undefined} padding={0} onClick={onClick} disableHoverEffects={!onClick} style={{ width: "100%", height: "100%" }} containerStyle={{ ...getWitnessCardSurfaceStyle({ isAnimated: false, isSticky }), width: "100%", height: "100%" }}>
                    <StaticWitnessCardImage data={data}/>
                    <CwitnesscardGradientOverlay />
                    <CwitnesscardContent data={data} isSticky={true}/>
                </Cbutton>
            </div>
        </div>
        ;
}
